// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Lryn","right":"styles_right__3X5pb"};